import React from 'react';
import './OurClients.css';

import netflixLogo from '../assets/brands/netflix.png';
import amazonPrimeLogo from '../assets/brands/prime.png';
import tataLogo from '../assets/brands/tata.png';
import ceatLogo from '../assets/brands/ceat.png';
import manyawarLogo from '../assets/brands/manyawar.png';
import campaLogo from '../assets/brands/campa.png';
import excelLogo from '../assets/brands/excel.png';
import airIndiaLogo from '../assets/brands/airIndia.png';
import hyundaiLogo from '../assets/brands/hyundai.png';
import dsGroupLogo from '../assets/brands/ds.png';
import dharmaLogo from '../assets/brands/dharma.png';
import jungleBookLogo from '../assets/brands/jb.jpg';
import viraasiLogo from '../assets/brands/viraasi.png';
import rsvpLogo from '../assets/brands/rsvp.jpg';
import twamevLogo from '../assets/brands/twamev.png';

const OurClients = () => {
  const clients = [
    { name: "Netflix", logo: netflixLogo, url: "https://www.netflix.com" },
    { name: "Amazon Prime", logo: amazonPrimeLogo, url: "https://www.primevideo.com/offers/nonprimehomepage/ref=dv_web_force_root" },
    { name: "Tata", logo: tataLogo, url: "https://www.tata.com" },
    { name: "CEAT", logo: ceatLogo, url: "https://www.ceat.com" },
    { name: "Manyawar", logo: manyawarLogo, url: "https://www.manyavar.com/?utm_source=google_ay&utm_medium=paid_search&utm_campaign=ind-all_many_search_roas_all_alwayson&utm_content=bottom_troas_all_exactmatch&utm_creative=_14969_adyogi_google_many_BrandSearch-SB_d2c_roas_ind-all_alwayson_Exactmatch_08122023&utm_term=manyavar&gad_source=1&gad_campaignid=19527569660&gbraid=0AAAAADjM5rdwRDyAeCd17KKwLwjvOcWo6&gclid=Cj0KCQjwjo7DBhCrARIsACWauSmnO-cc4fRwv2auvmGQavBu4CgGS495vq5wbqZxSvcYZH11vsHGN58aAnFbEALw_wcB" },
    { name: "Campa", logo: campaLogo, url: " https://campabeverages.com" },
    { name: "Excel Entertainment", logo: excelLogo, url: "https://www.excelmovies.com" },
    { name: "Air India", logo: airIndiaLogo, url: "https://www.airindia.com" },
    { name: "Hyundai", logo: hyundaiLogo, url: "https://www.hyundai.com/in/en" },
    { name: "DS Group", logo: dsGroupLogo, url: "https://www.dsgroup.com" },
    { name: "Dharma Productions", logo: dharmaLogo, url: "https://dharma-production.com" },
    { name: "Jungle Book Studio", logo: jungleBookLogo, url: "https://junglebook.studio" },
    { name: "Viraasi", logo: viraasiLogo, url: "https://www.rsvpmovies.com/" },
    { name: "RSVP Movies", logo: rsvpLogo, url: "https://www.instagram.com/rsvpmovies/" },
    { name: "Twamev", logo: twamevLogo, url: "https://www.twamev.com/en-in/couple/bestsellers?utm_source=google_ay&utm_medium=paid_search&utm_campaign=ind-p4_TWAM_14975_adyogi_Brand-Search_Engage_D2C_Allind-all_twam_search_purchase_ond&utm_content=bottom_maxconv_all_all_exactmatch&&utm_creative=TWAM_14975_adyogi_Brand-Search_Engage_D2C_All&gad_source=1&gad_campaignid=21834101657&gbraid=0AAAAA-N1mN7I9vSh25J9skCnn6miYwhfx&gclid=Cj0KCQjwjo7DBhCrARIsACWauSn9lcwEhCJmj0cfQDLEfut6K_xNPALQZAjKD6_F5p1OPtWVmRL4gRQaApl3EALw_wcB" },
  ];

  return (
    <div className="our-clients">
      <h2>Our Clients</h2>
      <div className="client-logos">
        <div className="logos-container">
          {clients.concat(clients).map((client, index) => (
            <div key={index} className="client-logo">
              <a
                href={client.url}
                target="_blank"
                rel="noopener noreferrer"
                title={client.name}
              >
                <img src={client.logo} alt={client.name} className="clogo-img" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurClients;
